import moment from 'moment';

export function Task(defaults = {}) {
  return {
    ...(defaults.id && {
      id: defaults.id,
    }),
    type: defaults.type || null,
    title: defaults.title || null,
    place: defaults.place || null,
    image: defaults.image || null,
    steps: defaults.steps || null,
    status: defaults.status || null,
    taskSessions: defaults.taskSessions ? defaults.taskSessions.map(session => ({
      ...session,
      date: moment(session.date).format("YYYY-MM-DD"),
    })) : null,
    couponCode: defaults.couponCode || null,
    description: defaults.description || null,
    couponPoints: defaults.couponPoints || null,
    specifications: defaults.specifications || null,
    deductCouponCode: defaults.deductCouponCode || null,
    deductCouponPoints: defaults.deductCouponPoints || null,
    volunteeringFieldId: defaults.volunteeringFieldId || null,
    canUploadAttachment: defaults.canUploadAttachment || false,
    endAt: defaults.endAt ? moment(defaults.endAt).format("YYYY-MM-DD") : null,
    startAt: defaults.startAt ? moment(defaults.startAt).format("YYYY-MM-DD") : null,
    maxSessionsPerVolunteer: defaults.maxSessionsPerVolunteer || null,
    maxSessionDaysPerVolunteer: defaults.maxSessionDaysPerVolunteer || null
  };
}

// نسخة جاهزة للإنشاء من فرصة قائمة: بدون معرّف أو حالة، والجلسات تُنسخ كجلسات جديدة
export function TaskDuplicate(defaults = {}) {
  const task = Task(defaults);
  delete task.id;
  task.status = null;
  task.sessions = (task.taskSessions || []).map((session) => ({
    date: session.date,
    startAt: session.startAt,
    endAt: session.endAt,
    maxSeats: session.maxSeats,
  }));
  task.taskSessions = null;
  return task;
}

function toDateOnly(value) {
  if (!value) return null;
  return String(value).substring(0, 10);
}

function toShortTime(value) {
  if (!value) return null;
  return String(value).substring(0, 5);
}

function toFullTime(value) {
  if (!value) return null;
  const time = String(value);
  return time.length === 5 ? `${time}:00` : time;
}

// صلاحيات المشرف في موقع المشرفين بترتيب العرض
export const SUPERVISOR_PERMISSION_LABELS = {
  view_tasks: "عرض المهام",
  view_volunteer_groups: "عرض متطوعي المجموعة",
  view_zadi_sessions: "عرض جلسات زادي",
  check_in_zadi_sessions: "تسجيل الحضور في جلسات زادي",
  view_thank_you_messages: "عرض رسائل الشكر",
};

// يرفضها السيرفر لمشرف بلا مجموعات
export const SUPERVISOR_GROUP_PERMISSIONS = ["view_tasks", "view_volunteer_groups", "view_thank_you_messages"];

// صلاحيات المشرف العادي، وهي افتراضي السيرفر عند الإنشاء مع مجموعات
export const SUPERVISOR_DEFAULT_PERMISSIONS = ["view_tasks", "view_volunteer_groups", "view_zadi_sessions", "view_thank_you_messages"];

// تسميات مختصرة لشرائح جدول المشرفين
export const SUPERVISOR_PERMISSION_SHORT_LABELS = {
  view_tasks: "المهام",
  view_volunteer_groups: "المجموعات",
  view_zadi_sessions: "جلسات زادي",
  check_in_zadi_sessions: "تسجيل الحضور",
  view_thank_you_messages: "رسائل الشكر",
};

export function sessionSupervisorNames(session) {
  const supervisors = session.supervisors || [];
  return supervisors.length ? supervisors.map((supervisor) => supervisor.name).join("، ") : "-";
}

export function ZadiSession(defaults = {}) {
  return {
    ...(defaults.id && {
      id: defaults.id,
    }),
    title: defaults.title || null,
    description: defaults.description || null,
    date: toDateOnly(defaults.date),
    startTime: toShortTime(defaults.startTime),
    endTime: toShortTime(defaults.endTime),
    totalSeats: defaults.totalSeats == null ? null : defaults.totalSeats,
    supervisorIds: (defaults.supervisors || []).map((supervisor) => supervisor.id),
    attendCouponCode: defaults.attendCouponCode || null,
    noShowCouponCode: defaults.noShowCouponCode || null,
    unregisteredAttendCouponCode: defaults.unregisteredAttendCouponCode || null
  };
}

export function toZadiSessionPayload(model = {}) {
  return {
    title: model.title,
    description: model.description,
    date: toDateOnly(model.date),
    startTime: toFullTime(model.startTime),
    endTime: toFullTime(model.endTime),
    totalSeats: model.totalSeats == null || model.totalSeats === '' ? null : Number(model.totalSeats),
    // يستبدل السيرفر مجموعة المشرفين كاملة عند التعديل
    supervisorIds: model.supervisorIds || [],
    attendCouponCode: model.attendCouponCode,
    noShowCouponCode: model.noShowCouponCode,
    unregisteredAttendCouponCode: model.unregisteredAttendCouponCode
  };
}
